import script from "./PatientsDatatableTDPaymentFiscalCheque.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsDatatableTDPaymentFiscalCheque.vue?vue&type=script&setup=true&lang=js"

import "./PatientsDatatableTDPaymentFiscalCheque.vue?vue&type=style&index=0&id=ae9e83b2&lang=scss"

const __exports__ = script;

export default __exports__